export const tiles = {
  "tiles" : [
    {
      "id": "A-1",
      "letter": "A"
    },
    {
      "id": "A-2",
      "letter": "A"
    },
    {
      "id": "A-3",
      "letter": "A"
    },
    {
      "id": "A-4",
      "letter": "A"
    },
    {
      "id": "A-5",
      "letter": "A"
    },
    {
      "id": "A-6",
      "letter": "A"
    },
    {
      "id": "A-7",
      "letter": "A"
    },
    {
      "id": "A-8",
      "letter": "A"
    },
    {
      "id": "A-9",
      "letter": "A"
    },
    {
      "id": "A-10",
      "letter": "A"
    },
    {
      "id": "A-11",
      "letter": "A"
    },
    {
      "id": "A-12",
      "letter": "A"
    },
    {
      "id": "A-13",
      "letter": "A"
    },
    {
      "id": "B-1",
      "letter": "B"
    },
    {
      "id": "B-2",
      "letter": "B"
    },
    {
      "id": "B-3",
      "letter": "B"
    },
    {
      "id": "C-1",
      "letter": "C"
    },
    {
      "id": "C-2",
      "letter": "C"
    },
    {
      "id": "C-3",
      "letter": "C"
    },
    {
      "id": "D-1",
      "letter": "D"
    },
    {
      "id": "D-2",
      "letter": "D"
    },
    {
      "id": "D-3",
      "letter": "D"
    },
    {
      "id": "D-4",
      "letter": "D"
    },
    {
      "id": "D-5",
      "letter": "D"
    },
    {
      "id": "D-6",
      "letter": "D"
    },
    {
      "id": "E-1",
      "letter": "E"
    },
    {
      "id": "E-2",
      "letter": "E"
    },
    {
      "id": "E-3",
      "letter": "E"
    },
    {
      "id": "E-4",
      "letter": "E"
    },
    {
      "id": "E-5",
      "letter": "E"
    },
    {
      "id": "E-6",
      "letter": "E"
    },
    {
      "id": "E-7",
      "letter": "E"
    },
    {
      "id": "E-8",
      "letter": "E"
    },
    {
      "id": "E-9",
      "letter": "E"
    },
    {
      "id": "E-10",
      "letter": "E"
    },
    {
      "id": "E-11",
      "letter": "E"
    },
    {
      "id": "E-12",
      "letter": "E"
    },
    {
      "id": "E-13",
      "letter": "E"
    },
    {
      "id": "E-14",
      "letter": "E"
    },
    {
      "id": "E-15",
      "letter": "E"
    },
    {
      "id": "E-16",
      "letter": "E"
    },
    {
      "id": "E-17",
      "letter": "E"
    },
    {
      "id": "E-18",
      "letter": "E"
    },
    {
      "id": "F-1",
      "letter": "F"
    },
    {
      "id": "F-2",
      "letter": "F"
    },
    {
      "id": "F-3",
      "letter": "F"
    },
    {
      "id": "G-1",
      "letter": "G"
    },
    {
      "id": "G-2",
      "letter": "G"
    },
    {
      "id": "G-3",
      "letter": "G"
    },
    {
      "id": "G-4",
      "letter": "G"
    },
    {
      "id": "H-1",
      "letter": "H"
    },
    {
      "id": "H-2",
      "letter": "H"
    },
    {
      "id": "H-3",
      "letter": "H"
    },
    {
      "id": "I-1",
      "letter": "I"
    },
    {
      "id": "I-2",
      "letter": "I"
    },
    {
      "id": "I-3",
      "letter": "I"
    },
    {
      "id": "I-4",
      "letter": "I"
    },
    {
      "id": "I-5",
      "letter": "I"
    },
    {
      "id": "I-6",
      "letter": "I"
    },
    {
      "id": "I-7",
      "letter": "I"
    },
    {
      "id": "I-8",
      "letter": "I"
    },
    {
      "id": "I-9",
      "letter": "I"
    },
    {
      "id": "I-10",
      "letter": "I"
    },
    {
      "id": "I-11",
      "letter": "I"
    },
    {
      "id": "I-12",
      "letter": "I"
    },
    {
      "id": "J-1",
      "letter": "J"
    },
    {
      "id": "J-2",
      "letter": "J"
    },
    {
      "id": "K-1",
      "letter": "K"
    },
    {
      "id": "K-2",
      "letter": "K"
    },
    {
      "id": "L-1",
      "letter": "L"
    },
    {
      "id": "L-2",
      "letter": "L"
    },
    {
      "id": "L-3",
      "letter": "L"
    },
    {
      "id": "L-4",
      "letter": "L"
    },
    {
      "id": "L-5",
      "letter": "L"
    },
    {
      "id": "M-1",
      "letter": "M"
    },
    {
      "id": "M-2",
      "letter": "M"
    },
    {
      "id": "M-3",
      "letter": "M"
    },
    {
      "id": "N-1",
      "letter": "N"
    },
    {
      "id": "N-2",
      "letter": "N"
    },
    {
      "id": "N-3",
      "letter": "N"
    },
    {
      "id": "N-4",
      "letter": "N"
    },
    {
      "id": "N-5",
      "letter": "N"
    },
    {
      "id": "N-6",
      "letter": "N"
    },
    {
      "id": "N-7",
      "letter": "N"
    },
    {
      "id": "N-8",
      "letter": "N"
    },
    {
      "id": "O-1",
      "letter": "O"
    },
    {
      "id": "O-2",
      "letter": "O"
    },
    {
      "id": "O-3",
      "letter": "O"
    },
    {
      "id": "O-4",
      "letter": "O"
    },
    {
      "id": "O-5",
      "letter": "O"
    },
    {
      "id": "O-6",
      "letter": "O"
    },
    {
      "id": "O-7",
      "letter": "O"
    },
    {
      "id": "O-8",
      "letter": "O"
    },
    {
      "id": "O-9",
      "letter": "O"
    },
    {
      "id": "O-10",
      "letter": "O"
    },
    {
      "id": "O-11",
      "letter": "O"
    },
    {
      "id": "P-1",
      "letter": "P"
    },
    {
      "id": "P-2",
      "letter": "P"
    },
    {
      "id": "P-3",
      "letter": "P"
    },
    {
      "id": "Q-1",
      "letter": "Q"
    },
    {
      "id": "Q-2",
      "letter": "Q"
    },
    {
      "id": "R-1",
      "letter": "R"
    },
    {
      "id": "R-2",
      "letter": "R"
    },
    {
      "id": "R-3",
      "letter": "R"
    },
    {
      "id": "R-4",
      "letter": "R"
    },
    {
      "id": "R-5",
      "letter": "R"
    },
    {
      "id": "R-6",
      "letter": "R"
    },
    {
      "id": "R-7",
      "letter": "R"
    },
    {
      "id": "R-8",
      "letter": "R"
    },
    {
      "id": "R-9",
      "letter": "R"
    },
    {
      "id": "S-1",
      "letter": "S"
    },
    {
      "id": "S-2",
      "letter": "S"
    },
    {
      "id": "S-3",
      "letter": "S"
    },
    {
      "id": "S-4",
      "letter": "S"
    },
    {
      "id": "S-5",
      "letter": "S"
    },
    {
      "id": "S-6",
      "letter": "S"
    },
    {
      "id": "T-1",
      "letter": "T"
    },
    {
      "id": "T-2",
      "letter": "T"
    },
    {
      "id": "T-3",
      "letter": "T"
    },
    {
      "id": "T-4",
      "letter": "T"
    },
    {
      "id": "T-5",
      "letter": "T"
    },
    {
      "id": "T-6",
      "letter": "T"
    },
    {
      "id": "T-7",
      "letter": "T"
    },
    {
      "id": "T-8",
      "letter": "T"
    },
    {
      "id": "T-9",
      "letter": "T"
    },
    {
      "id": "U-1",
      "letter": "U"
    },
    {
      "id": "U-2",
      "letter": "U"
    },
    {
      "id": "U-3",
      "letter": "U"
    },
    {
      "id": "U-4",
      "letter": "U"
    },
    {
      "id": "U-5",
      "letter": "U"
    },
    {
      "id": "U-6",
      "letter": "U"
    },
    {
      "id": "V-1",
      "letter": "V"
    },
    {
      "id": "V-2",
      "letter": "V"
    },
    {
      "id": "V-3",
      "letter": "V"
    },
    {
      "id": "W-1",
      "letter": "W"
    },
    {
      "id": "W-2",
      "letter": "W"
    },
    {
      "id": "W-3",
      "letter": "W"
    },
    {
      "id": "X-1",
      "letter": "X"
    },
    {
      "id": "X-2",
      "letter": "X"
    },
    {
      "id": "Y-1",
      "letter": "Y"
    },
    {
      "id": "Y-2",
      "letter": "Y"
    },
    {
      "id": "Y-3",
      "letter": "Y"
    },
    {
      "id": "Z-1",
      "letter": "Z"
    },
    {
      "id": "Z-2",
      "letter": "Z"
    }
  ]
}